import { z } from 'zod';
import { ConversionFormStepField } from '../types';
export function makeFieldSchema(field: ConversionFormStepField): z.ZodType | undefined {
  switch (field.__typename) {
    case 'ConversionFormStepsFieldsInputField':
      {
        return field.required ? z.string().min(1, {
          error: field.requiredMessage ?? 'This field is required'
        }) : z.string().optional();
      }
    case 'ConversionFormStepsFieldsNumberField':
      {
        return field.required ? z.number().min(1, {
          error: field.requiredMessage ?? 'This field is required'
        }) : z.number().optional();
      }
    case 'ConversionFormStepsFieldsCheckboxList':
      {
        const stringEnumSchema = z.enum(field.values?.map(s => s?.value) as readonly string[]);
        let arraySchema = z.array(stringEnumSchema);
        if (!field.minSelected && !field.maxSelected) {
          return arraySchema.optional();
        }
        if (field.maxSelected) {
          arraySchema = arraySchema.max(field.maxSelected, {
            error: `At most ${field.maxSelected} ${field.maxSelected === 1 ? 'option' : 'options'} must be selected.`
          });
        }
        if (field.minSelected) {
          arraySchema = arraySchema.min(field.minSelected, {
            error: `At least ${field.minSelected} ${field.minSelected === 1 ? 'option' : 'options'} must be selected.`
          });
        }
        return arraySchema;
      }
    case 'ConversionFormStepsFieldsCompanyNameField':
      {
        return field.required ? z.string().min(1, {
          error: field.requiredMessage ?? 'This field is required'
        }) : z.string().optional();
      }
    case 'ConversionFormStepsFieldsEmailField':
      {
        return field.required ? z.email({
          message: field.requiredMessage ?? 'Please enter a valid email address'
        }) : z.email().optional();
      }
    case 'ConversionFormStepsFieldsPhoneNumberField':
      {
        return field.required ? z.string().min(1, {
          error: field.requiredMessage ?? 'This field is required'
        }) : z.string().optional();
      }
    case 'ConversionFormStepsFieldsMessageField':
      {
        return field.required ? z.string().min(1, {
          error: field.requiredMessage ?? 'This field is required'
        }) : z.string().optional();
      }
    case 'ConversionFormStepsFieldsUrlField':
      {
        return field.required ? z.hostname({
          error: field.requiredMessage ?? 'Please enter a valid URL'
        }) : z.string().optional();
      }
    case 'ConversionFormStepsFieldsNumberField':
      {
        return field.required ? z.number().min(1, {
          error: field.requiredMessage ?? 'This field is required'
        }) : z.number().optional();
      }
    case 'ConversionFormStepsFieldsRadioList':
    case 'ConversionFormStepsFieldsRadioImageList':
      {
        const stringEnumSchema = z.union([z.literal(''), z.enum(field.values?.map(s => s?.value) as readonly string[])]);
        return field.required ? stringEnumSchema.refine(v => v !== '', {
          error: field.requiredMessage ?? 'Please select an option.'
        }) : stringEnumSchema.optional();
      }
    case 'ConversionFormStepsFieldsFullNameField':
      {
        return field.required ? z.string().min(1, {
          error: field.requiredMessage ?? 'This field is required'
        }) : z.string().optional();
      }
    case 'ConversionFormStepsFieldsSliderField':
      {
        const stringEnumSchema = z.enum(field.values?.map(s => s?.value) as readonly string[], field.requiredMessage ?? 'Please select an option.');
        return field.required ? stringEnumSchema : stringEnumSchema.optional();
      }
    default:
      return;
  }
}